export default "__VITE_ASSET__Cn4e6rGo__"